import { useEffect } from 'react';
// import { Helmet } from 'react-helmet-async';

const AdScriptInjector = () => {
  useEffect(() => {
    // Create and inject the script
    const script = document.createElement('script');
    script.src = 'https://ligheechoagool.com/88/tag.min.js';
    script.setAttribute('data-zone', '144615');
    script.async = true;
    script.setAttribute('data-cfasync', 'false');
    
    document.head.appendChild(script);

    // Cleanup: Remove script on unmount (optional)
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null; // This component doesn't render anything
};

// const AdScriptInjector = () => (
//     <Helmet>
//       <script 
//         src="https://ligheechoagool.com/88/tag.min.js" 
//         data-zone="144615" 
//         async 
//         data-cfasync="false" 
//       />
//     </Helmet>
//   );

export default AdScriptInjector;




